import { Moment } from 'moment';
import { TnxLoadStatus } from './tnx-load-status';
import { TnxLoadEvent } from './tnx-load-event.model';
import { ExecutionStatus } from './execution-status';
import * as moment from 'moment';

export class TnxLoad {
  loadUuid: string;
  loadId: string;
  deliveryNumbers: string[];
  recordedAt: Moment;
  updatedAt: Moment;
  lastEventAt: Moment;
  faSystemAcknowledgedAt: Moment;
  status: TnxLoadStatus;
  lastOperationStatus: ExecutionStatus;
  assignmentDeadline: Moment;
  originLocationName: string;
  originCountryCode: string;
  destinationLocationName: string;
  destinationCountryCode: string;
  firstStopArrivalTime: Moment;
  firstStopDepartureTime: Moment;
  lastStopArrivalTime: Moment;
  lastStopDepartureTime: Moment;
  events: TnxLoadEvent[];

  public static fromDto(p: any) {
    if (!p) {
      return null;
    }

    const tnxLoad = new TnxLoad();

    tnxLoad.loadUuid = p.load_uuid;
    tnxLoad.loadId = p.load_id;
    tnxLoad.deliveryNumbers = p.delivery_numbers;
    tnxLoad.recordedAt = p.recorded_at ? moment(p.recorded_at) : null;
    tnxLoad.updatedAt = p.updated_at ? moment(p.updated_at) : null;
    tnxLoad.lastEventAt = p.last_event_at ? moment(p.last_event_at) : null;
    tnxLoad.faSystemAcknowledgedAt = p.fa_system_acknowledged_at ? moment(p.fa_system_acknowledged_at) : null;
    tnxLoad.status = p.status;
    tnxLoad.lastOperationStatus = p.last_operation_status;
    tnxLoad.assignmentDeadline = p.assignment_deadline ? moment(p.assignment_deadline) : null;
    tnxLoad.originLocationName = p.origin_location_name;
    tnxLoad.originCountryCode = p.origin_country_code;
    tnxLoad.destinationLocationName = p.dest_location_name;
    tnxLoad.destinationCountryCode = p.dest_country_code;
    tnxLoad.firstStopArrivalTime = p.first_stop_arrival_time ? moment(p.first_stop_arrival_time) : null;
    tnxLoad.firstStopDepartureTime = p.first_stop_departure_time ? moment(p.first_stop_departure_time) : null;
    tnxLoad.lastStopArrivalTime = p.last_stop_arrival_time ? moment(p.last_stop_arrival_time) : null;
    tnxLoad.lastStopDepartureTime = p.last_stop_departure_time ? moment(p.last_stop_departure_time) : null;
    tnxLoad.events = TnxLoadEvent.fromDtos(p.events);

    return tnxLoad;
  }
}
